import CitySEOHead from "@/components/feature/CitySEOHead";
import NewOrleansHeroSection from "./components/HeroSection";
import NewOrleansStickyNav from "./components/StickyNav";
import NewOrleansProcessingTimeSection from "./components/ProcessingTimeSection";
import NewOrleansServicesSection from "./components/ServicesSection";
import NewOrleansLocalAreaSection from "./components/LocalAreaSection";
import NewOrleansTravelTimingSection from "./components/TravelTimingSection";
import NewOrleansDestinationsSection from "./components/DestinationsSection";
import NewOrleansTestimonialsSection from "./components/TestimonialsSection";
import NewOrleansAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import NewOrleansComparisonSection from "./components/ComparisonSection";
import NewOrleansMistakesSection from "./components/MistakesSection";
import NewOrleansHowItWorksSection from "./components/HowItWorksSection";
import NewOrleansFAQSection, { faqs } from "./components/FAQSection";
import NewOrleansHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import NewOrleansFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function NewOrleansPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="New Orleans"
        state="Louisiana"
        stateAbbr="LA"
        route="/cities/new-orleans"
        title="Emergency Passport New Orleans, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in New Orleans, LA — as fast as 24 hours. Cruise, study-abroad, and oil industry travelers served. A+ BBB rated, registered State Dept. courier serving Greater New Orleans, Metairie, Kenner, and Southeast Louisiana."
        geoPlacename="New Orleans, Louisiana"
        geoPosition="29.9511;-90.0715"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
        hasPhysicalOffice
      />
      <NewOrleansHeroSection />
      <NewOrleansStickyNav />
      <NewOrleansProcessingTimeSection />
      <NewOrleansLocalAreaSection />
      <NewOrleansServicesSection />
      <NewOrleansTravelTimingSection />
      <NewOrleansDestinationsSection />
      <NewOrleansTestimonialsSection />
      <NewOrleansAcceptanceFacilitiesSection />
      <NewOrleansComparisonSection />
      <NewOrleansMistakesSection />
      <NewOrleansHowItWorksSection />
      <NewOrleansFAQSection />
      <NewOrleansHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/new-orleans" state="LA" />
      <NewOrleansFinalCTA />
    </div>
  );
}